import { Component, NgModule, OnInit } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticationService, UserRole } from './core/authentication/authentication.service';
import { AppRoute } from './shared/app.route.enum';
import { AuthenticationGuard } from './core/authentication/authentication.guard';
import { MatCardModule } from '@angular/material/card';
import { canActivateAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';

// Example forbidden component to which the user will be redirected to if
// he is not authenticated or authorized
@Component({
  templateUrl: './core/forbidden.component.html',
  imports: [MatCardModule],
})
export class ForbiddenComponent implements OnInit {
  user: any;

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): any {
    this.authenticationService.login().subscribe(() => {
      this.user = this.authenticationService.credentials.user;
    });
  }
}

export const routes: Routes = [
  { path: 'login/callback', component: OktaCallbackComponent },
  {
    path: '',
    redirectTo: `/${AppRoute.Dashboard}`,
    pathMatch: 'full',
    title: 'Dashboard',
  },
  {
    path: AppRoute.Dashboard,
    loadChildren: () =>
      import('@app/dashboard/dashboard-detail.module').then((m) => m.DashboardDetailModule),
    canActivate: [canActivateAuthGuard, AuthenticationGuard],
    title: 'Dashboard',
    data: {
      roles: [UserRole.DisUser, UserRole.DisTester],
    },
  },
  {
    path: AppRoute.DeliveryNotifications,
    loadChildren: () =>
      import('@app/delivery-notifications/delivery-notifications.module').then(
        (m) => m.DeliveryNotificationsModule,
      ),
    canActivate: [canActivateAuthGuard, AuthenticationGuard],
    title: 'Delivery Notifications',
    data: {
      roles: [
        UserRole.ApplicationAdmin,
        UserRole.DeliveryNotificationManager,
        UserRole.DeliveryNotificationUser,
      ],
    },
  },
  {
    path: AppRoute.Users,
    loadChildren: () => import('@app/users/users.module').then((m) => m.UsersModule),
    canActivate: [canActivateAuthGuard, AuthenticationGuard],
    title: 'Users',
    data: { roles: [UserRole.ApplicationAdmin] },
  },
  {
    path: AppRoute.Companies,
    loadChildren: () => import('@app/companies/companies.module').then((m) => m.CompaniesModule),
    canActivate: [canActivateAuthGuard, AuthenticationGuard],
    title: 'Companies',
    data: { roles: [UserRole.ApplicationAdmin] },
  },
  {
    path: AppRoute.ReturnProcess,
    loadChildren: () =>
      import('@app/return-process/return-process.module').then((m) => m.ReturnProcessModule),
    canActivate: [canActivateAuthGuard, AuthenticationGuard],
    title: 'Return Process',
    data: {
      roles: [
        UserRole.ApplicationAdmin,
        UserRole.ReturnManager,
        UserRole.ReturnUser,
        UserRole.CustomsUser,
      ],
    },
  },
  {
    path: AppRoute.News,
    loadChildren: () => import('@app/news/news.routes').then((m) => m.NEWS_ROUTES),
    canActivate: [canActivateAuthGuard, AuthenticationGuard],
    title: 'News',
    data: { roles: [UserRole.ApplicationAdmin] },
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }, // Fallback route,
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
